import { useCallback } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

import { APP_ROUTES, normalizePathname } from '../navigation/appRoutes';

const LOCATIONS_PATH = APP_ROUTES.schedule.locations;

/**
 * Blocks in-app navigation away from the locations route and warns on tab close / refresh
 * when there is an unsaved location draft. Pair with {@link LocationDraftLeaveConfirmModal}.
 */
export function useLocationDraftLeaveGuard(hasUnsavedDraft: boolean) {
  const blocker = useBlocker(
    useCallback(
      ({ currentLocation, nextLocation }) => {
        if (!hasUnsavedDraft) return false;
        return (
          normalizePathname(currentLocation.pathname) === LOCATIONS_PATH &&
          normalizePathname(nextLocation.pathname) !== LOCATIONS_PATH
        );
      },
      [hasUnsavedDraft],
    ),
  );

  useBeforeUnload(
    useCallback(
      (event: BeforeUnloadEvent) => {
        if (!hasUnsavedDraft) return;
        event.preventDefault();
      },
      [hasUnsavedDraft],
    ),
  );

  return blocker;
}
